import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=b85cbe3e&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=b85cbe3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85cbe3e",
  null
  
)

export default component.exports